import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Link from "@material-ui/core/Link";
import Divider from "@material-ui/core/Divider";

import NoticeIcon from "../../../../Assets/Logo/NoticeIcon.svg";
import TimetableIcon from "../../../../Assets/Logo/TimetableIcon.svg";
import ExaminationIcon from "../../../../Assets/Logo/ExaminationIcon.svg";
import FeeIcon from "../../../../Assets/Logo/FeeIcon.svg";
import AttendanceIcon from "../../../../Assets/Logo/AttendanceIcon.svg";
import TransportIcon from "../../../../Assets/Logo/TransportIcon.svg";
import InventoryIcon from "../../../../Assets/Logo/InventoryIcon.svg";
import LibraryIcon from "../../../../Assets/Logo/LibraryIcon.svg";

import { useStyles } from "./DashboardQuickLinks.css";

class DashboardQuickLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quickLinks: [
        {
          name: "Notice",
          url: "/administration/notices",
          icon: (
            <img
              src={NoticeIcon}
              alt="Notice"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "TimeTable",
          url: "/administration/timetable/overall",
          icon: (
            <img
              src={TimetableIcon}
              alt="Timetable"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Examination",
          url: "/administration/examconfig",
          icon: (
            <img
              src={ExaminationIcon}
              alt="Examination"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Fees",
          url: "/administration/Fees-Manage",
          icon: (
            <img src={FeeIcon} alt="Fee" style={{ width: 30, height: 30 }} />
          ),
        },
        {
          name: "Attendance",
          url: "/administration/Student-Attendance",
          icon: (
            <img
              src={AttendanceIcon}
              alt="Attendance"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Transportation",
          url: "/administration/vehicle",
          icon: (
            <img
              src={TransportIcon}
              alt="Transport"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Inventory",
          url: "/administration/inventory",
          icon: (
            <img
              src={InventoryIcon}
              alt="Inventory"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
        {
          name: "Library",
          url: "/administration/library",
          icon: (
            <img
              src={LibraryIcon}
              alt="Library"
              style={{ width: 30, height: 30 }}
            />
          ),
        },
      ],
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <Paper className={classes.root}>
        <div style={{ fontSize: 18, fontWeight: "bold" }}>Quick Links</div>
        <Divider />
        <Grid container spacing={3} style={{ padding: 20 }}>
          {this.state.quickLinks.map((linkData, index) => (
            <Grid item xs={12} sm={6} md={3} xl={3} lg={3} key={index}>
              <div className={classes.content}>
                {linkData.icon}
                <Link href={linkData.url} style={{ marginLeft: 10 }}>
                  {linkData.name}
                </Link>
              </div>
            </Grid>
          ))}
        </Grid>
      </Paper>
    );
  }
}

export default withStyles(useStyles)(DashboardQuickLinks);
